import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "/genealogy/search",
    name: "genealogy.search",
    component: () => import("./pages/GenealogySearch.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      title: "Buscador de Personas",
      breadcrumb: ["Genealogía", "Buscador de Personas"],
    },
  },
  {
    path: "/genealogy/review",
    name: "genealogy.review",
    component: () => import("./pages/PersonReview.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      requiresAdmin: true,
      roles: ["ADMIN"],
      title: "Pendientes de revisión",
      breadcrumb: ["Genealogía", "Pendientes de revisión"],
    },
  },
  {
    path: "/genealogy/event/:id",
    name: "genealogy.event.detail",
    component: () => import("./pages/EventDetail.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      title: "Ficha de Evento",
      breadcrumb: ["Genealogía", "Ficha de Evento"],
    },
  },
  {
    path: "/person/:id",
    name: "genealogy.person.detail",
    component: () => import("./pages/PersonDetail.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      title: "Ficha de Persona",
      breadcrumb: ["Genealogía", "Ficha de Persona"],
    },
  },
  {
    path: "/genealogy/person/new",
    name: "genealogy.person.new",
    component: () => import("./pages/PersonForm.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      requiresAdmin: true,
      roles: ["ADMIN"],
      title: "Alta de Persona",
      breadcrumb: ["Genealogía", "Alta de Persona"],
    },
  },
  {
    path: "/genealogy/person/:id/edit",
    name: "genealogy.person.edit",
    component: () => import("./pages/PersonForm.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      requiresAdmin: true,
      roles: ["ADMIN"],
      title: "Editar Persona",
      breadcrumb: ["Genealogía", "Editar Persona"],
    },
  },
  {
    path: "/genealogy/event/new",
    name: "genealogy.event.new",
    component: () => import("./pages/EventForm.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      requiresAdmin: true,
      roles: ["ADMIN"],
      title: "Alta de Evento",
      breadcrumb: ["Genealogía", "Alta de Evento"],
    },
  },
  {
    path: "/genealogy/event/:id/edit",
    name: "genealogy.event.edit",
    component: () => import("./pages/EventForm.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      requiresAdmin: true,
      roles: ["ADMIN"],
      title: "Editar Evento",
      breadcrumb: ["Genealogía", "Editar Evento"],
    },
  },
  {
    path: "/genealogy/geography",
    name: "genealogy.geography",
    component: () => import("./pages/GeographyAdmin.vue"),
    meta: {
      auth: true,
      requiresAuth: true,
      requiresAdmin: true,
      roles: ["ADMIN"],
      title: "Poblaciones y Parroquias",
      breadcrumb: ["Genealogía", "Poblaciones y Parroquias"],
    },
  },
];
